import {downloadCsv} from "./csvExport";
import {toJalali} from "./helpers";
import VOTE_LABELS from "./voteLabels";

const formatDate = (value) => value ? toJalali(value, "jYYYY-jMM-jDD_HH:mm") : "";

const exportVoteList = (rows = []) => {
  const voteRows = Array.isArray(rows) ? rows : [];
  if (!voteRows.length) return;

  downloadCsv([
    ["شناسه", "شماره بلیت", "رأی", "نام فیلم", "نام بخش", "سالن", "سانس", "تاریخ ثبت"],
    ...voteRows.map((item) => [
      item?.id ?? "",
      item?.ticket_code ?? item?.ticket?.code ?? "",
      VOTE_LABELS[item?.vote] ?? item?.vote ?? "",
      item?.ticket?.movie?.name ?? item?.ticket?.movie_name ?? item?.movie_name ?? "",
      item?.movie_section?.name ?? "—",
      item?.ticket?.schedule?.venue_name ?? "",
      formatDate(item?.ticket?.schedule?.start_at),
      formatDate(item?.created_at),
    ]),
  ], `votes-${Date.now()}.csv`);
};

export default exportVoteList;
